var baseW = 986; // 固定幅を980に設定
// var ua = navigator.userAgent.toLowerCase();
// var isiOS = (ua.indexOf("iphone") > -1) || (ua.indexOf("ipod") > -1) || (ua.indexOf("ipad") > -1);

function updateMetaViewport() {
    var viewportContent;
    // var w = window.outerWidth;
    var w = window.innerWidth;
    var viewportMeta = document.querySelector("meta[name='viewport']");
  console.log("修正前のmetaは", viewportMeta);
    

    if (w < baseW) {
        viewportContent = "width=980";  // 980px以下のデバイスでは固定幅
    } else {
        viewportContent = "width=device-width,initial-scale=1";  // PC等の幅が広いデバイスではレスポンシブ
    }
    console.log("baseWは", baseW);
    console.log("wは", w);
    console.log("contentは", viewportContent);

    console.log("修正前のmetaは", viewportMeta);
    if (!viewportMeta) {
        viewportMeta = document.createElement("meta");
        viewportMeta.name = "viewport";
        document.head.appendChild(viewportMeta);
    }

    viewportMeta.setAttribute("content", viewportContent);
    console.log("修正後のmetaは", viewportMeta);
}

// 初回イベント強制発動
document.addEventListener("DOMContentLoaded", function() {
    updateMetaViewport();
  console.log("初回読み込み時");
});

// イベントハンドラ登録
window.addEventListener("resize", updateMetaViewport, true);
window.addEventListener("orientationchange", updateMetaViewport, true);